import $ from 'jquery';

export default {
  triggerClass: '.accordion__link',
  panelClass: '.accordion__content',

  _bindEvents() {

    const triggers = document.querySelectorAll(this.triggerClass);
    [].forEach.call(triggers, trigger => {
      trigger.addEventListener('click', e => {
        e.preventDefault();
        this.toggle(trigger);
      });
    });
  },

  init() {
    this._bindEvents();
  },

  toggle(trigger) {
    const controls = trigger.getAttribute('aria-controls');
    let expanded = trigger.getAttribute('aria-expanded');
    expanded = (expanded == 'true') ? 'false' : 'true';
    $(`#${controls}`).slideToggle(170);
    trigger.setAttribute('aria-expanded', expanded);
  },
}
